import { ThumbsUp } from "lucide-react";
import SimpUserBadge from "components/_Pages/Profile/SimpUserBadge";
import React from "react";
import { Button } from "components/ui/v2";
import { IMessage } from "types/Message.type";

interface EndorsementItemProps {
  message: IMessage;
  onEndorse?: (message: IMessage) => void;
  loading?: boolean;
  compact?: boolean;
}

const EndorsementItem: React.FC<EndorsementItemProps> = ({
  message,
  onEndorse,
  loading = false,
  compact = false,
}) => (
  <div className={`flex max-w-full justify-between rounded-md ${compact ? "gap-2 px-2 py-2" : "gap-2 px-2 py-2"}`}>
    {message?.createdBy && (
      <SimpUserBadge
        user={message.createdBy}
        showEmail={false}
        customElement={
          <div className="flex items-center justify-between">
            <span className={`${compact ? "text-xs" : "text-md"} font-semibold`}>
              {message?.skill?.name}
            </span>
          </div>
        }
      />
    )}
    <div className="flex items-center">
      <Button
        variant="primary"
        className={compact ? "h-7 min-h-[28px] px-2" : "h-auto"}
        onClick={() => onEndorse?.(message)}
        loading={loading}
      >
        <ThumbsUp className="h-4 w-4" />
      </Button>
    </div>
  </div>
);

export default EndorsementItem;
